import React from 'react';
import '../whychoose/whychoose.css';
import { useTranslation } from "react-i18next";
import boxImage1 from '../../assets/images/why-01.svg';
import boxImage2 from '../../assets/images/why-02.svg';
import boxImage3 from '../../assets/images/why-03.svg';
const Whychoose = () => {
    const { t } = useTranslation();

    return (
        <div>
            <section className="why" id="about">
                <div className="why-img">
                    <img src={require("../../assets/images/ab-men.png")} alt="img" className="img-fluid" />
                </div>
                <div className="container">
                    {/* <div className="row align-items-center">
                    <div className="col-md-12 col-lg-6">
                        <div className="why-images">
                            <div className="why-img">
                                <img src={require("../../assets/images/about.png")} alt="img" className="img-fluid" />
                                <div className="why-img2">
                                    <img src={require("../../assets/images/about-2.jpg")} alt="img" className="img-fluid" />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <div className="why-content">
                            <h5 className="sub-title">Why Choose Us?</h5>
                            <h3 className="title"> Expert Insurance Comparison Service</h3>
                            <ul className="why-list">
                                <li>
                                    <h5>Convenience</h5>
                                    <p>Say goodbye to the hassle of visiting multiple websites or making countless phone
                                        calls to get insurance quotes. With Suq Al Tamin, you can compare quotes from
                                        multiple providers within minutes, all from the comfort of your own home.</p>
                                </li>
                                <li>
                                    <h5>Save Time and Money</h5>
                                    <p>By comparing quotes side by side, you can easily identify the best coverage options
                                        at the most competitive prices. Our goal is to help you save both time and money
                                        when shopping for insurance.</p>
                                </li>
                                <li>
                                    <h5>Expert Guidance</h5>
                                    <p>Not sure which policy is right for you? Our team of insurance experts is here to
                                        help. We'll guide you through the process and answer any questions you may have,
                                        ensuring that you make an informed decision. </p>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>  */}
                    <div className='row justify-content-end'>
                        <div className='col-md-12 col-lg-7'>
                            <div className='why-title text-center'>
                                <h3>{t('whyUs.title')}</h3>
                                <h5>{t('whyUs.subtitle')}</h5>
                            </div>
                            <div className='row'>
                                <div className='col-md-4 col-sm-12 col-12'>
                                    <div className='box-why-choose'>
                                        <div className='box-why-image'>
                                            <img src={boxImage1} alt="img" className="img-fluid" />
                                        </div>
                                        <h5>{t('whyUs.benefits.card1.title')}</h5>
                                        <p>{t('whyUs.benefits.card1.description')}</p>
                                    </div>
                                </div>
                                <div className='col-md-4 col-sm-12 col-12'>
                                    <div className='box-why-choose'>
                                        <div className='box-why-image'>
                                            <img src={boxImage2} alt="img" className="img-fluid" />
                                        </div>
                                        <h5>{t('whyUs.benefits.card2.title')}</h5>
                                        <p>{t('whyUs.benefits.card2.description')}</p>
                                    </div>
                                </div>
                                <div className='col-md-4 col-sm-12 col-12'>
                                    <div className='box-why-choose'>
                                        <div className='box-why-image'>
                                            <img src={boxImage3} alt="img" className="img-fluid" />
                                        </div>
                                        <h5>{t('whyUs.benefits.card3.title')}</h5>
                                        <p>{t('whyUs.benefits.card3.description')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Whychoose;